import React from "react";
import PropTypes from "prop-types";

import USPoliticsMapLoaderCrosstabs from "./USPoliticsMapLoaderCrosstabs.js";
import EasternEuropeMapLoaderCrosstabs from "./EasternEuropeMapLoaderCrosstabs.js";
import ChinaMapLoaderCrossTabs from "./ChinaMapLoaderCrossTabs.js";

const MapLoaderCrosstabs = (props) => {
	const { baseMap, noTimeline } = props;
	// console.log("map loader", baseMap);
	// default is usa
	return baseMap === "politics2020" ? (
		<USPoliticsMapLoaderCrosstabs {...props} noTimeline={noTimeline} />
	) : baseMap === "gec" || baseMap === 'oseRussia' || baseMap === "balticsDemo" || baseMap === "gec_analyst" ? (
		<EasternEuropeMapLoaderCrosstabs {...props} noTimeline={noTimeline} />
	) : baseMap === "china" || baseMap === "australia2022" || baseMap === "oseAusChina" ? (
		<ChinaMapLoaderCrossTabs {...props} noTimeline={noTimeline} />
	) : (
		<USPoliticsMapLoaderCrosstabs {...props} noTimeline={noTimeline} />
	);
};

MapLoaderCrosstabs.defaultProps = {
	baseMap: null,
	noTimeline: true,
};

MapLoaderCrosstabs.propTypes = {
	baseMap: PropTypes.string,
	noTimeline: PropTypes.bool,
};

export default MapLoaderCrosstabs;
